import React, { useState } from "react";
import "./App.css";
import { DataProvider } from "./context/DataContext";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import PartnersSection from "./components/PartnersSection";
import ActivitiesSection from "./components/ActivitiesSection";
import ResourcesSection from "./components/ResourcesSection";
import DisseminationSection from "./components/DisseminationSection";
import Footer from "./components/Footer";
import AdminPanel from "./components/AdminPanel";

function App() {
  const [activeTab, setActiveTab] = useState('home');

  const renderContent = () => {
    switch (activeTab) {
      case 'home':
        return <HeroSection setActiveTab={setActiveTab} />;
      case 'about':
        return <AboutSection setActiveTab={setActiveTab} />;
      case 'partners':
        return <PartnersSection setActiveTab={setActiveTab} />;
      case 'activities':
        return <ActivitiesSection setActiveTab={setActiveTab} />;
      case 'resources':
        return <ResourcesSection setActiveTab={setActiveTab} />;
      case 'impact':
        return <DisseminationSection setActiveTab={setActiveTab} />;
      case 'admin':
        return <AdminPanel setActiveTab={setActiveTab} />;
      default:
        return <HeroSection setActiveTab={setActiveTab} />;
    }
  };

  return (
    <DataProvider>
      <div className="App">
        <Navbar activeTab={activeTab} setActiveTab={setActiveTab} />
        <main className="pt-20">
          {renderContent()}
        </main>
        {activeTab !== 'admin' && <Footer setActiveTab={setActiveTab} />}
      </div>
    </DataProvider>
  );
}

export default App;
